export default __webpack_public_path__ + "static/media/Act3_Vastaaja.64ee2dd7.svg";